import * as user from "./user";
import * as devices from "./devices";
import * as pets from "./pets";
import * as billing from "./billing";

export const UserAPI = new user.UserAPI();
export const DevicesAPI = new devices.DevicesAPI();
export const BillingAPI = new billing.BillingAPI();
export const PetsAPI = new pets.PetsAPI();